<template>    
    <div class="help-description-vertical background-dotted pa-10">

        <h4>Pagalba ir įrankiai</h4>

        <br>

        <p>Srityje „Mano turinys“ rodomi visi Jūsų susikurti ar su Jumis pasidalinti interaktyvūs ir spausdinimui skirti atlasai</p>

        <v-list-item>
            <v-list-item-content>
                <v-list-item-title>
                    <a href="https://www.geoportal.lt/geoportal/pradziamokslis"><v-icon class="pr-3">mdi-youtube</v-icon> Susikurkite pirmąjį atlasą</a>
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <v-list-item>
            <v-list-item-content>
                <v-list-item-title>
                    <a href="https://www.geoportal.lt/geoportal/pradziamokslis"><v-icon class="pr-3">mdi-book-search</v-icon> Pagalba</a>
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <v-list-item>
            <v-list-item-content>
                <v-list-item-title>
                    <router-link to="/gallery">
						<v-icon class="pr-3">mdi-lightbulb-on</v-icon> Peržiūrėkite pavyzdžius
					</router-link>
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <br>

        <p>Pritrūko resursų? Parašykite mums ir suteiksime Jūsų idėjoms daugiau vietos.</p>

        <v-list-item>
            <v-list-item-content>
                <v-list-item-title>
                    <a v-on:click="askForMoreResources"><v-icon class="pr-3">mdi-chart-line</v-icon> Prašykite papildomų resursų</a>
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <v-list-item>
            <v-list-item-content>
                <v-list-item-title>
                    <a href="https://www.geoportal.lt/geoportal/pradziamokslis"><v-icon class="pr-3">mdi-email-plus</v-icon> Parašykite administratoriams</a>
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <MoreResourcesRequestForm />

    </div>    

</template>

<script>

    import MoreResourcesRequestForm from "../admin/MoreResourcesRequestForm";
    export default {
		components: {
			MoreResourcesRequestForm
		},
		methods: {
			askForMoreResources: function(){
				this.$vBus.$emit("show-more-resources-request-form");
			}
		}
	};
</script>